import { BACKEND_URL_PREFIX, itemsOnPage } from "../utils/const";
import {
  NETWORK_REQUEST_SENT,
  GET_YEAR_SCIENTIFIC_WORK_STARTED,
  GET_YEAR_SCIENTIFIC_WORK_COMPLETED,
  GET_TYPEOF_SCIENTIFIC_WORK_STARTED,
  GET_TYPEOF_SCIENTIFIC_WORK_COMPLETED,
  SCIENTIFIC_WORK_FETCH_COMPLETED,
  SCIENTIFIC_WORK_FETCH_STARTED,
  SCIENTIFIC_WORK_FETCH_FAILED,
  SET_SCIENTIFIC_WORK_COUNT,
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import { createNotification } from "../components/notifications/notifications";
 
export const getScientificWorkYear = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type:GET_YEAR_SCIENTIFIC_WORK_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/orderdate`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({
        type:GET_YEAR_SCIENTIFIC_WORK_COMPLETED,
        scientificWorkYear: result.order_date,
      });
    }
  }
};

// // ВИД РАБОТ  typeScientificWork
export const getScientificWorkOrdertype = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: GET_TYPEOF_SCIENTIFIC_WORK_STARTED });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/ordertypes`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      dispatch({
        type:GET_TYPEOF_SCIENTIFIC_WORK_COMPLETED,
        scientificWorkTypeof: result.order_type,
      });
    }
  }
};

export const getScientificWorkList = ( params) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  const {orderdate, faculty, ordertypes, orderstate, ordernum, numberPage, by_user, from_date, to_date } = params
  const by_user_state = by_user == true ? 'True' : 'False'
  const countParams = from_date !==0 ? {
    by_user: by_user_state,
    paginateFrom: numberPage * itemsOnPage,
    maxResults: itemsOnPage,
    to_date: to_date ,
    from_date: from_date ,
  } : {
    by_user: by_user_state,
    paginateFrom: numberPage * itemsOnPage,
    maxResults: itemsOnPage,
  }
 
  const urlParams = new URLSearchParams(countParams).toString();
  if (getState().auth.token) {
    dispatch({ type: SCIENTIFIC_WORK_FETCH_STARTED });
    const response = await fetch(
      ordernum !=0 ?
      `${BACKEND_URL_PREFIX}/srw/${orderdate}/${faculty}/${ordertypes}/${orderstate}/${ordernum}?${urlParams}`
       :
      `${BACKEND_URL_PREFIX}/srw/${orderdate}/${faculty}/${ordertypes}/${orderstate}/all?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const result = await response.json();
      const payload = Math.ceil(result.count / itemsOnPage)
      dispatch({
        type: SCIENTIFIC_WORK_FETCH_COMPLETED,
        scientificWorkList: result.scientific_research_work_table,
      });
      dispatch({ type: SET_SCIENTIFIC_WORK_COUNT, data: payload });

    }  else {
      dispatch({ type: SCIENTIFIC_WORK_FETCH_FAILED});
    }
  }
};


// by_user=False by_user=true